import { useTranslation } from 'react-i18next';

import { Heading } from '@app/shared/ui/atoms/Common';
import { magicStickImage } from '@app/assets';

export function MagicLoadingContent() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center">
      <Heading level={2} className="text-center">
        {t('loader.magic')}
      </Heading>
      <img src={magicStickImage} alt="magic stick" className="w-[60px]" />
    </div>
  );
}
